var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    fill: "#84D5DC",
    fillOpacity: 0.1,
    stroke: "#51A3AA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.59375 8.99951C9.59375 8.37646 9.9375 7.81787 10.4531 7.53857V11.7495H11.4844V7.28076H12.5156V11.7495H13.5469V7.53857C14.041 7.81787 14.4062 8.37646 14.4062 8.99951V11.7495H15.4375V8.99951C15.4375 7.49561 14.1914 6.24951 12.6875 6.24951H11.3125C9.78711 6.24951 8.5625 7.49561 8.5625 8.99951V11.7495H9.59375V8.99951ZM16.7695 13.5972L16.5332 12.9097C16.4473 12.6304 16.1895 12.437 15.8887 12.437H8.08984C7.78906 12.437 7.53125 12.6304 7.44531 12.9097L7.20898 13.5972C7.05859 14.0483 7.40234 14.4995 7.875 14.4995V16.9058C7.875 17.0991 8.02539 17.2495 8.21875 17.2495H8.90625C9.07812 17.2495 9.25 17.0991 9.25 16.9058V14.4995H14.75V16.9058C14.75 17.0991 14.9004 17.2495 15.0938 17.2495H15.7812C15.9531 17.2495 16.125 17.0991 16.125 16.9058V14.4995C16.5762 14.4995 16.9199 14.0483 16.7695 13.5972Z",
    fill: "#51A3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChair);
export default __webpack_public_path__ + "static/media/chair.54a9fe0adc3174d32b023d37c4a7ecb2.svg";
export { ForwardRef as ReactComponent };